<template>
  <confirmation-slip :manifests="manifests" />
</template>

<script>
import { mapActions } from 'vuex'
import ConfirmationSlip from '../../../components/_ConfirmationSlip'

export default {
  comments: "受渡確認票",
  name: 'DriverOrderConfirmationSlip',
  components: {
    ConfirmationSlip
  },
  mixins: [],
  props: {},
  data() {
    return {
      manifests: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    const params = this.$route.query
    this.fetchManifests({ params: params }).then((content) => {
      this.manifests = content.manifests
    })
  },
  methods: {
    ...mapActions('DriverOrderConfirmationSlip', {
      fetchManifests: 'index',
    }),
  }
}
</script>

<style scoped lang="scss">
body {
  overflow-y: scroll;
  height: auto;
}
.container-layout {
  border: solid 1px #ddd;
  background-color: #fff;
  & .manifest {
    width: 210mm;
    height: 297mm;
    margin: 0 auto;

  }
}
.table {
  border-top: 1px solid #999;
  border-left: 1px solid #999;
  width: 204mm;
}

.table_line {
  display: table;
  width: 100%;
  height: 8mm;
}

.block {
  display: table-cell;
  vertical-align: initial;
  &.label {
    background-color: #dddddd;
    text-align: center;
    font-size: 70%;
  }
  &.bordered {
    border-right: solid 1px #999;
    border-bottom: solid 1px #999;
  }
  & span {
    font-size: 75%;
    vertical-align: center;
  }
  & p {
    font-size: 60%;
    margin-bottom: 0;
  }

}

hr {
  page-break-after: always;
}
@media print {
  .container-layout {
    border: none;
  }
  .print-break {
    page-break-after: always;
    border: none;
  }
}
</style>
